export default {
  name: 'ProductTabAdditional',
  props: {
    categories: {
      type: [Array, null],
      default: () => null
    }
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    getFormattedTitle(title, index, length) {
      return index + 1 < length ? `${title},` : title;
    }
  }
};
